// extracted by mini-css-extract-plugin
module.exports = {"content":"DockerComposePreview_content__2IOJU","content__pre":"DockerComposePreview_content__pre__ma39B","content__pre__copy":"DockerComposePreview_content__pre__copy__mXUJA"};